import {
  CategoryAction
} from './const';
import {
  scrollById
} from './utils';
import {
  updateBasketFromList
} from './action';
import {
  Filters
} from './category/filters';
import {
  SortProducts
} from './category/sort';
import {
  Loadmore
} from './category/loadmore';
import {
  Counter
} from './category/counter';
import {
  initSlider
} from './photo-slider';
import {
  Links
} from './category/links';
import {
  lazy
} from '../base';

export class Category {

  constructor() {
    this._elem = document.querySelector('.category');

    if (this._elem === null) {
      return;
    }

    this._aside = this._elem.querySelector('.category__aside');
    this._main = this._elem.querySelector('.category__main');
    this._list = this._main.querySelector('.category__list');
    this._title = document.querySelector('.page__title');
    this._pagination = this._main.querySelector('.category__pagination');
    this._filters = new Filters(this._aside);
    this._counter = new Counter(this._main);
    this._sort = new SortProducts(this._main);
    this._loadmore = new Loadmore(this._main);
    this._links = new Links();

    this._handleReplaceHtml = this._handleReplaceHtml.bind(this);
    this._handleShowSearchModel = this._handleShowSearchModel.bind(this);

    this._filters.setFiltersHandler(this._handleReplaceHtml);

    this._setHandlers();
  }

  _getProductCount() {
    return this._list.children.length;
  }

  _handleReplaceHtml(action, str) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(str, 'text/html');
    this._data = doc;
    this._replaceHtml(action);
    this._setHandlers();
  }

  _replaceHtml(action) {

    const list = this._data.querySelector('.category__list');

    this._replaceTitle();
    this._replaceSort();
    this._replaceCounter();

    switch (action) {
      case CategoryAction.SORT:
        this._replaceProducts(list);
        break;
      case CategoryAction.FILTERS:
        this._replaceProducts(list);
        break;
      case CategoryAction.LOADMORE:
        this._appendProducts(list);
        break;
      default:
        this._replaceProducts(list);
        break;
    }

    this._replacePagination();
    initSlider();
    lazy.update();
  }

  _replaceTitle() {
    const title = this._data.querySelector('.page__title');
    this._title.replaceWith(title);
    this._title = document.querySelector('.page__title');
  }

  _replaceSort() {
    const sort = this._data.querySelector('#sort_count');
    this._sort.getElem().replaceWith(sort);
    this._sort = new SortProducts(this._main);
  }

  _replaceCounter() {
    const counter = this._data.querySelector('.counter');
    this._counter.getElem().replaceWith(counter);
    this._counter = new Counter(this._main);
    this._counter.update();
  }

  _replaceProducts(list) {
    this._list.replaceWith(list);
    this._list = this._main.querySelector('.category__list');
  }

  _appendProducts(list) {
    const fragment = document.createDocumentFragment();
    const products = list.children;
    Array.from(products).forEach((product) => fragment.appendChild(product));
    this._list.appendChild(fragment);
  }

  _replacePagination() {
    const pagination = this._data.querySelector('.category__pagination');
    this._pagination.replaceWith(pagination);
    this._pagination = this._main.querySelector('.category__pagination');

    this._loadmore = new Loadmore(this._main);
  }

  _setHandlers() {
    this._sort.setSelectChangeHandler(this._handleReplaceHtml);
    this._loadmore.setButtonClickHandler(this._handleReplaceHtml);
    if (this._links.isExist()) {
      this._links.setSearchButtonClickHandler(this._handleShowSearchModel);
    }
    updateBasketFromList();
  }

  _handleShowSearchModel(evt) {
    const button = evt.currentTarget;
    let id;

    if (button.dataset.type === 'brand') {
      id = 'filter-brand';
    } else if (button.dataset.type === 'model') {
      id = 'filter-16';
    }

    if (id) {
      this._findAndScrollToFilter(id);
    }

  }

  _findAndScrollToFilter(id) {
    const filter = this._filters.getFilter(id);

    if (filter) {
      scrollById(`[data-id='${id}']`, 100);
      setTimeout(() => {
        filter.goToSearch();
      }, 500);
    }
  }
}
